import { render, staticRenderFns } from "./SelectedItemHeader.vue?vue&type=template&id=5de2ac17&lang=pug&"
import script from "./SelectedItemHeader.vue?vue&type=script&lang=js&"
export * from "./SelectedItemHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports